import { getJobIdFromParams } from "@/helpers/jobs";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { ErrorResponse } from "@/components/profile/types";

export const getJobDetails = (): UseQueryResult<any, Error> => {
  return useQuery({
    queryKey: ["jobDetails"],
    retry: false,
    queryFn: async () => {
      const apiParams = new URLSearchParams(window.location.search);
      const jobId = getJobIdFromParams(apiParams);

      apiParams.set("kiwiJobId", jobId);

      let apiParamsString = apiParams.toString();
      if (apiParamsString.includes("jobId")) {
        apiParamsString = apiParamsString.replace(/jobId=/, "jobid=");
      }

      const response = await fetch(
        `/seeker-profile/api/getJobDetails?${apiParamsString}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
  });
};
